import { formatDate } from "@/lib/Formatters/formatDate";

type TimelineAgreement = {
  created_at?: string | null;
  sent_at?: string | null;
  viewed_at?: string | null;
  signed_at?: string | null;
  declined_at?: string | null;
  voided_at?: string | null;
  decline_reason?: string | null;
  signer_name?: string | null;
};

export function AgreementTimeline({
  agreement,
}: {
  agreement: TimelineAgreement;
}) {
  if (agreement.voided_at) {
    return (
      <>
        Voided on {formatDate(agreement.voided_at)}
        {agreement.signed_at
          ? ` — was signed by ${agreement.signer_name ?? "driver"} on ${formatDate(agreement.signed_at)}`
          : ""}
      </>
    );
  }

  if (agreement.signed_at) {
    return (
      <>
        Signed by {agreement.signer_name ?? "driver"} on{" "}
        {formatDate(agreement.signed_at)}
      </>
    );
  }

  if (agreement.declined_at) {
    return (
      <>
        Declined on {formatDate(agreement.declined_at)}
        {agreement.decline_reason ? ` — ${agreement.decline_reason}` : ""}
      </>
    );
  }

  if (agreement.viewed_at) {
    return <>Viewed by driver on {formatDate(agreement.viewed_at)}</>;
  }

  if (agreement.sent_at) {
    return <>Sent on {formatDate(agreement.sent_at)}</>;
  }

  return (
    <>
      Draft created
      {agreement.created_at ? ` ${formatDate(agreement.created_at)}` : ""}
    </>
  );
}
